import { getRoleBadgeClasses } from '@/utils/role';
import type { RoleDetail } from '../types/rolesDetail.types';

interface RoleInfoBlockProps {
  role: RoleDetail | null;
  isLoading?: boolean;
}

export function RoleInfoBlock({ role, isLoading }: RoleInfoBlockProps) {
  if (isLoading || !role) return <div className="h-48 animate-pulse rounded-md border border-slate-100 bg-white p-3" />;

  const items = [
    { label: 'Thành viên', value: role.memberCount },
    { label: 'Tổng quyền', value: role.permissionCount },
    { label: 'Quyền rủi ro cao', value: role.highRiskCount },
  ];

  return (
    <section className="rounded-md border border-slate-100 bg-white p-3 shadow-sm">
      <div className="space-y-2 text-sm">
        <div className="flex flex-col gap-2 border-b border-slate-100 pb-2 md:flex-row md:items-center md:justify-between">
          <div className="space-y-2">
            <h2 className="text-lg font-medium text-slate-900">{role.name}</h2>
            <div className="flex flex-wrap items-center gap-2">
              <span className={getRoleBadgeClasses(role.code)}>{role.code}</span>
              <span className="rounded-md bg-slate-100 px-2 py-1 text-sm font-semibold text-slate-600">
                {role.isSystem ? 'Hệ thống' : 'Tùy chỉnh'}
              </span>
            </div>
          </div>
          <p className="max-w-2xl text-slate-500">{role.description || 'Chưa có mô tả cho vai trò này.'}</p>
        </div>
        <div className="grid gap-3 sm:grid-cols-3">
          {items.map((item) => (
            <div key={item.label} className="rounded-md bg-slate-50 p-3 text-sm">
              <p className="text-slate-500">{item.label}</p>
              <p className="mt-1 text-2xl font-medium text-slate-950">{item.value}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
